// Import the functions you need from Firebase SDK
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// ✅ Exported Firebase configuration object
export const firebaseConfig = {
  apiKey: "AIzaSyB4GFCAk6CT4HeRVHv2Y1qSbQU208rHZ98",
  authDomain: "pbis-app-72ba5.firebaseapp.com",
  projectId: "pbis-app-72ba5",
  storageBucket: "pbis-app-72ba5.firebasestorage.app",
  messagingSenderId: "873447342491",
  appId: "1:873447342491:web:7cf31789d902912d23e13e",
  measurementId: "G-XTXETN9KL7",
};

// ✅ Primary Firebase App
export const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// ✅ Connect to emulators in local development
if (false) {
  console.log("🧪 Using Firebase emulators");

  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", {
      disableWarnings: true,
    });
  } catch {}

  try {
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
  } catch {}

  try {
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  } catch {}
}

// ✅ Analytics (only runs in supported browser environments)
let analytics = null;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

// ✅ Export all needed Firebase services
export { auth, db, storage, functions, analytics };
